import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';

const createPlaceholder = (placeholder: Maybe<string>) =>
    placeholder ? `data:image/webp;base64, ${placeholder}` : undefined;

export default createPlaceholder;
